import { useState, useRef } from "react";

export function Tooltip({ children, text, titolo, placement = "bottom" }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  const show = () => setOpen(true);
  const hide = () => setOpen(false);

  return (
    <span
      className={`tooltip-wrapper tooltip-${placement}`}
      tabIndex={0}
      onClick={(e) => setOpen((v) => !v)}        // toggle su tap
      onBlur={hide}                               // chiudi quando perdi focus
      onMouseEnter={show} onMouseLeave={hide}     // desktop hover
      ref={ref}
      aria-expanded={open}
    >
      {children}
      <span className="tooltip" role="tooltip" style={{
        opacity: open ? 1 : 0,
        visibility: open ? "visible" : "hidden",
        transform: open ? "translateY(0)" : undefined
      }}>
        <h4>{titolo}: </h4>
        <ul>
        {text.split(',').map((t, i) => {
            return <li key={i}>{t.split('|')[1] ? t.split('|')[1] : t} </li>
          })
        }

        </ul>
      </span>
    </span>
  );
}